import { render, staticRenderFns } from "./Heading-Main.vue?vue&type=template&id=42bf7e0e&scoped=true&"
import script from "./Heading-Main.vue?vue&type=script&lang=js&"
export * from "./Heading-Main.vue?vue&type=script&lang=js&"
import style0 from "./Heading-Main.vue?vue&type=style&index=0&id=42bf7e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bf7e0e",
  null
  
)

export default component.exports